import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import * as api from '../../api/api';
import { Select } from 'rmwc/Select';
import StatusMessage from '../../util/StatusMessage'
import {default as Reactsel} from "react-select";
import ReactTooltip from 'react-tooltip'
import { ListItemGraphic} from 'rmwc/List';

class StrengthAndDevelopment extends Component{
	constructor(props) {
    	super(props)
    	this.state = {
            userAccess: false,
    		selectedSwotDetails: [],
    		data:{
    			swotTagDetails: [],
                userAssociations: []
    		},
            swotData: {
                swotId: ''
            },
            errorMsg: ''
    	}
    }

    handleBackAction = (e) => {
        e.preventDefault()

        this.props.history.push('/portal/app/user/my_learning_arc_section')
    }

    componentDidMount() {
    	let data = Object.assign({}, this.state.data)

        return api.fetchUserSwotTags(this.props.user.accessToken)
        .then((result) => {
            if(result.status == 'success'){
                data.swotTagDetails = result.data.swot_tags
                data.userAssociations = result.data.user_associations
                this.setState({data: data, userAccess: true})
            }
            else if (result.status == 'no_access'){
                this.setState({userAccess: false})
            }
            else {
                this.setState({errorMsg: 'The server encountered an error while fetching. Please try again after sometime.'})
            }
        })
    }

    handleSwotChanges = (option) => {
        this.setState(state => {
            return {
               selectedSwotDetails : option
            };
        });
    }

    deleteSwotAssociation = (e, associationId) => {
        e.preventDefault()
        let data = Object.assign({}, this.state.data)
        
        api.deleteUserSwotAssociations(this.props.user.accessToken, associationId)
        .then((result) => {
            if (result.status == 'success'){
                data.swotTagDetails = result.data.swot_tags
                data.userAssociations = result.data.user_associations
                this.setState({data: data, selectedSwotDetails: []})
            }
            else {
                this.setState({errorMsg: 'The server encountered an error while deleting your association. Please try again after sometime.'})
            }
        })
    }

    saveAsStrength = (e) => {
    	e.preventDefault()
        let data = Object.assign({}, this.state.data)
        if (this.state.selectedSwotDetails.length === 0) {
            return this.setState({errorMsg: 'Please select a minimum of One Competency to add as a Strength.'})
        }
        console.log(this.state.selectedSwotDetails)
        let values = {
            'association' : 1,
            'swotTags' : this.state.selectedSwotDetails
        }
    	
        api.insertUserSwotAssociations(this.props.user.accessToken, values)
        .then((result) => {
            if (result.status == 'success'){
                data.swotTagDetails = result.data.swot_tags
                data.userAssociations = result.data.user_associations
                this.setState({data: data, selectedSwotDetails: [], errorMsg: ''})
            }
            else {
                this.setState({errorMsg: 'The server encountered an error while adding as Strength. Please try again after sometime.'})
            }
        })
    }

    saveUnderDevelopment = (e) => {
        e.preventDefault()
        let data = Object.assign({}, this.state.data)
        if (this.state.selectedSwotDetails.length === 0) {
            return this.setState({errorMsg: 'Please select a minimum of One Competency to add to the Development section.'})
        }
        let values = {
            'association' : 2,
            'swotTags' : this.state.selectedSwotDetails
        }
        
        api.insertUserSwotAssociations(this.props.user.accessToken, values)
        .then((result) => {
            if (result.status == 'success'){
                data.swotTagDetails = result.data.swot_tags
                data.userAssociations = result.data.user_associations
                this.setState({data: data, selectedSwotDetails: [], errorMsg: ''})
            }
            else {
                this.setState({errorMsg: 'The server encountered an error while adding under Areas of Development. Please try again after sometime.'})
            }
        })
    }

    render() {
        let saveUnderDevelopment = this.saveUnderDevelopment
        let saveAsStrength = this.saveAsStrength
        let deleteSwotAssociation = this.deleteSwotAssociation
        let handleBackAction = this.handleBackAction
        let strengthComponent
        let developmentComponent
        let displayComponent
        let swotData = Object.assign({}, this.state.swotData)
        
        strengthComponent = (
            this.state.data.userAssociations.map(function(association){
                let associationId = association.id
                if (association.global_type == 'Strength'){
                    return (
                        <div>
                            <Card style={{padding: '5px'}}>
                                <Grid className="opportunity-list-item">
                                    <GridCell span = "10">
                                        <Typography use="subtitle1" align = "left">{association.swot_tag} </Typography>
                                    </GridCell>
                                    <GridCell span = "2">
                                         <button className="mdc-button" align = "right" aria-label="Favorite" style={{ width: '66%' }} onClick= {((e) => deleteSwotAssociation(e, associationId))}>Remove </button>
                                    </GridCell>
                                </Grid>
                            </Card>
                            <br/>
                        </div>
                    )
                }
            })
        )

        developmentComponent = (
            this.state.data.userAssociations.map(function(association){
                let associationId = association.id
                if (association.global_type == 'Areas of Development'){
                    return (
                        <div>
                            <Card style={{padding: '5px'}}>
                                <Grid className="opportunity-list-item">
                                    <GridCell span = "10">
                                        <Typography use="subtitle1" align = "left">{association.swot_tag} </Typography>
                                    </GridCell>
                                    <GridCell span = "2">
                                        <button className="mdc-button" align = "right" aria-label="Favorite" style={{ width: '66%' }} onClick= {((e) => deleteSwotAssociation(e, associationId))}>Remove</button>
                                    </GridCell>
                                </Grid>
                            </Card>
                            <br/>
                        </div>
                    )
                }
            })
        )
        if (this.state.userAccess === true){
            displayComponent = (
                <div>
                    <Grid>
                        <GridCell span = "2">
                            <Button raised style={{ width: '50%' }} onClick= {((e) => handleBackAction(e))}>Back</Button>
                        </GridCell>
                        <GridCell span = "12">
                            <Card style={{padding: '25px'}}>
                                <Typography use="headline6">My Strengths and Areas of Development(AOD)</Typography>
                            </Card>
                        </GridCell>
                    </Grid>
                    <Grid>
                        <GridCell span = "6">
                            <Reactsel
                                name="parentCompetency"
                                onChange={this.handleSwotChanges}
                                value={this.state.selectedSwotDetails}
                                options={this.state.data.swotTagDetails}
                                placeholder="--Select the Competencies--"
                                isMulti>
                            </Reactsel>
                        </GridCell>
                        <GridCell span="3">
                            <Button raised style={{ width: '80%' }} onClick= {((e) => saveAsStrength(e))}>Add as Strength</Button>
                        </GridCell>
                        <GridCell span="3">
                            <Button raised style={{ width: '80%' }} onClick= {((e) => saveUnderDevelopment(e))}>Add as AOD</Button>
                        </GridCell>  
                        <GridCell span="12">
                            <StatusMessage error_msg = {this.state.errorMsg} />
                        </GridCell>
                    </Grid>
                    <Grid>
                        <GridCell span = "6">
                            <div>
                                <Card style={{padding: '20px'}} className='outer-card-background-color'>
                                    <GridCell span = "12">
                                        <Card style={{padding: '20px'}} className='card-background-color'>
                                            <Typography use="subtitle1" align = "center"> Strengths </Typography>
                                        </Card>
                                        <br />
                                        {strengthComponent}
                                    </GridCell>
                                </Card>
                            </div>
                        </GridCell>
                        <GridCell span = "6">
                            <div>
                                <Card style={{padding: '20px'}} className='outer-card-background-color'>
                                    <GridCell span = "12">
                                        <Card style={{padding: '20px'}} className='card-background-color'>
                                            <Typography use="subtitle1" align = "center"> Areas of Development </Typography>
                                        </Card>
                                        <br />
                                        {developmentComponent}
                                    </GridCell>
                                </Card>
                            </div>
                        </GridCell>
                    </Grid>
                </div>
            )
        }
        else {
            displayComponent = (
                <Grid>
                    <GridCell span = "2">
                        <Button raised style={{ width: '50%' }} onClick= {((e) => handleBackAction(e))}>Back</Button>
                    </GridCell>
                    <GridCell span = "12">
                        <Card style={{padding: '25px'}}>
                            <Typography use="headline6">My Strengths and Areas of Development(AOD)</Typography>
                        </Card>
                    </GridCell>
                    <GridCell span = "12">
                        <Card style={{padding: '25px'}}>
                            <Typography use="subtitle2">You will be able to access this section in the coming days.</Typography>
                        </Card>
                    </GridCell>
                </Grid>
            )
        }

    	return (
    		<div>
    			{displayComponent}
    		</div>
    	)
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(StrengthAndDevelopment);


// WEBPACK FOOTER //
// ./src/views/roadmap/StrengthAndDevelopment.jsx